import React from "react";
import Navbar from "../components/Navbar";

const About = () => {
    return (
        <div>
            <Navbar/>
            <h1>ABOUT</h1>
        </div>
    );
};

export default About;
